/* fndry-comparison — scroll indicator, overflow detection, scroll reveal. */
(function () {
  'use strict';

  var SELECTOR = '[data-fndry-comparison]';

  function Comparison(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-fc-scroll]');
    this.table = root.querySelector('[data-fc-table]');
    this.bar = root.querySelector('[data-fc-bar]');
    this.thumb = root.querySelector('[data-fc-thumb]');
    this.observer = null;
    this.resizeObserver = null;
    this.frame = 0;

    this.resizeFrame = 0;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.measure = this.measure.bind(this);

    this.init();
  }

  Comparison.prototype.init = function () {
    if (this.viewport) {
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);
        if (this.table) this.resizeObserver.observe(this.table);
      }

      this.measure();
    }

    this.watchReveal();
  };

  /* ---- indicator ------------------------------------------------------- */

  Comparison.prototype.measure = function () {
    if (!this.viewport) return;

    var visible = this.viewport.clientWidth;
    var total = this.viewport.scrollWidth;
    var overflows = total - visible > 1;

    this.root.setAttribute('data-fc-overflow', overflows ? 'true' : 'false');

    if (!overflows || !this.thumb) return;

    var ratio = Math.max(visible / total, 0.12);
    this.thumb.style.setProperty('--fc-thumb-w', (ratio * 100).toFixed(3) + '%');
    this.position();
  };

  Comparison.prototype.position = function () {
    if (!this.thumb || !this.bar) return;

    var max = this.viewport.scrollWidth - this.viewport.clientWidth;
    if (max <= 0) return;

    var progress = Math.min(Math.max(this.viewport.scrollLeft / max, 0), 1);
    var travel = this.bar.clientWidth - this.thumb.clientWidth;

    this.thumb.style.setProperty('--fc-thumb-x', (progress * travel).toFixed(2) + 'px');
  };

  Comparison.prototype.onScroll = function () {
    if (this.frame) return;
    var self = this;
    this.frame = window.requestAnimationFrame(function () {
      self.frame = 0;
      self.position();
    });
  };

  /* P15 2026-10-23: window resizes (on iPhones, every toolbar collapse) and
     the observer both measure in the next frame, once, instead of reading
     layout inside the event or the observer callback. */
  Comparison.prototype.onResize = function () {
    if (this.resizeFrame) return;
    var self = this;
    this.resizeFrame = window.requestAnimationFrame(function () {
      self.resizeFrame = 0;
      self.measure();
    });
  };

  /* ---- reveal ---------------------------------------------------------- */

  Comparison.prototype.enter = function () {
    this.root.setAttribute('data-enter', '');
  };

  Comparison.prototype.rearm = function () {
    this.root.removeAttribute('data-enter');
  };

  Comparison.prototype.watchReveal = function () {
    if (this.root.getAttribute('data-fc-reveal') !== 'true') return;

    if (typeof IntersectionObserver !== 'function') {
      this.enter();
      return;
    }

    var self = this;

    this.observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) self.enter();
          else if (entry.boundingClientRect.top > 0) self.rearm();
        });
      },
      { rootMargin: '0px 0px -20% 0px', threshold: 0 }
    );

    this.observer.observe(this.root);
  };

  Comparison.prototype.destroy = function () {
    if (this.viewport) this.viewport.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    if (this.observer) this.observer.disconnect();
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.frame) window.cancelAnimationFrame(this.frame);
    if (this.resizeFrame) window.cancelAnimationFrame(this.resizeFrame);
    this.root.removeAttribute('data-fc-ready');
  };

  /* ---- boot ------------------------------------------------------------ */

  function mount(root) {
    if (!root || root.getAttribute('data-fc-ready') === 'true') return;
    root.setAttribute('data-fc-ready', 'true');

    try {
      root.fndryComparison = new Comparison(root);
    } catch (error) {
      // Never let a thrown script be the only thing holding the table hidden.
      root.setAttribute('data-enter', '');
      root.setAttribute('data-fc-overflow', 'true');
    }
  }

  function mountAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll(SELECTOR), mount);
    if (context !== document && context.matches && context.matches(SELECTOR)) mount(context);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(document); });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector ? event.target.querySelector(SELECTOR) : null;
    if (root && root.fndryComparison) root.fndryComparison.destroy();
  });

  // Selecting a row in the editor must never land on a row that is still
  // waiting for its reveal.
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (root) root.setAttribute('data-enter', '');
  });
})();